import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'wz-simple-layout',
  templateUrl: './simple-layout.component.html',
  styleUrls: ['./simple-layout.component.scss'],
  standalone: false,
})
export class SimpleLayoutComponent {
  constructor(protected router: Router) {}

  public goToHomePage() {
    this.router.navigate(['']);
  }
}
